<template>
  <v-dialog ref="chooseDateDialog" :value="ChooseDateDialogValue" @input="$emit('chooseDateClosed')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        Propose Dates Available
      </v-card-title>
      <v-card-text transition="fade-transition" class="text-center pb-0">
        <div class="text-center title">
          <v-icon color="secondary" size="75">rate_review</v-icon>
          <p>Rate & Review</p>
        </div>
        <v-container>
          <v-flex xs12>
            <p class="subtitle-1">Kindly Rate Influencer's Quality of Work</p>
            <v-rating
              v-model="submissionReview.approveRatings"
              color="secondary"
              size="45"
            ></v-rating>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12>
            <v-expand-transition>
              <div
                v-show="submissionReview.approveRatings > 0 && submissionReview.approveRatings <= 4"
              >
                <p class="subtitle-1">
                  <v-textarea
                    filled
                    label="How can we make this a 5 stars?"
                    v-model="submissionReview.approveSuggestion"
                  ></v-textarea>
                </p>
                <v-divider></v-divider>
              </div>
            </v-expand-transition>
          </v-flex>
          <!-- Propose Dates Radios -->
          <div v-if="post && post.propose_dates">
            <p class="subtitle-1 font-weight-bold mb-0">Proposed Dates</p>
            <p class="caption caption-text" style="font-size:13px!important">Please choose one of the dates here</p>
            <v-radio-group v-model="submissionReview.wantedLiveDate">
              <v-radio v-for="(date, index) in post.propose_dates" :key="index" :label="utils.func.formatCustomDate(date, 'DD-MM-YYYY')" :value="date"></v-radio>
            </v-radio-group>
          </div>
        </v-container>
        <!-- <p v-if="post && post.propose_dates">
          Proposed Dates: <strong>{{post.propose_dates.map(p => p).join(', ')}}</strong>
        </p>
        <v-date-picker
        v-model="submissionReview.wantedLiveDate"
        scrollable
        :allowed-dates="allowedDates">
          <v-spacer></v-spacer>
        </v-date-picker> -->
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="true"
          loader="bars"
          background-color="#000"
          color="secondary"
          width.number="180"
          height.number="180"
        />
      </v-card-text>
      <v-card-actions class="pb-3" style="justify-content:right">
        <v-btn color="secondary" @click="close">Cancel</v-btn>
        <v-btn
          color="success"
          :disabled="!submissionReview.wantedLiveDate"
          @click="submitApprove"
          @click.stop="askDate = false"
        >Approve</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import config from '@/config';
// import { mapState, mapGetters } from 'vuex';
import moment from 'moment'
import { mapState } from 'vuex';
import DatePicker from '@/components/scoped/custom/DatePicker'
import postAPIs from './postApi';
import Loading from 'vue-loading-overlay';
import utils from '@/utils'
export default {
  name: 'ClientChooseDateModal',
  components: {
    DatePicker,
    Loading
  },
  props: {
    post: Object,
    ChooseDateDialogValue: Boolean
  },
  data () {
    return {
      isLoading: false,
      submissionReview: {
        approveRatings: null,
        approveSuggestion: null,
        wantedLiveDate: null,
        propose_dates: []
      },
      utils
    }
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      postUpdateStatus: state => state.post.updated
    })
  },
  methods: {
    resetForm() {
      this.submissionReview = {
        approveRatings: null,
        approveSuggestion: null,
        wantedLiveDate: null,
        propose_dates: []
      }
      this.valid = true
    },
    close() {
      this.proposeDialogValue = false
      this.$emit('chooseDateClosed')
    },
    // saveWantedLiveDate() {
    //   this.$refs.dateDialog.save(this.submissionReview.wantedLiveDate)
    // },
    // async saveChangeDate() {
    //   this.$refs.dateDialog.save(this.submissionReview.wantedLiveDate)
    //   let saveData = [
    //     {
    //       id: this.post._id,
    //       propose_dates: this.submissionReview.propose_dates
    //     }
    //   ]
    //   await this.$store.dispatch('post/updatePostByIds', saveData)
    //   if (this.postUpdateStatus) {
    //     // Show success message
    //     this.$swal({
    //       text: 'Successfully saved.',
    //       type: 'success'
    //     });
    //     await this.$store.dispatch('post/sendProposeDateClientEmail', {
    //       id: this.post._id
    //     })
    //   }
    // },
    submitApprove() {
      if (this.submissionReview.approveRatings === null) {
        this.$swal({
          title: 'Rating is required',
          type: 'warning'
        })
      } else if (this.submissionReview.approveSuggestion === null &&
        this.submissionReview.approveCompliment === null) {
        this.$swal({
          title: 'Your comment is required',
          type: 'warning'
        })
      } else if (this.submissionReview.wantedLiveDate === null) {
        this.$swal({
          title: 'Rating is required',
          type: 'warning'
        })
      } else {
        // let msgTitle = ''
        // let confirmBtnText = ''
        // if (this.showApprove) {
        //   msgTitle = 'Do you want to approve this post?'
        //   confirmBtnText = 'Yes, Approve'
        // }
        // if (this.showChangeRequest) {
        //   msgTitle = 'Do you want to request date change this post?'
        //   confirmBtnText = 'Yes, Request Change'
        // }
        this.$swal({
          title: 'Do you want to approve this date?',
          type: 'question',
          confirmButtonText: 'Yes, Approve',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true
        }).then(result => {
          if (result.value) {
            let body = {
              rating: this.submissionReview.approveRatings,
              comment: this.submissionReview.approveSuggestion || this.submissionReview.approveCompliment,
              appLink: window.location.protocol + '//' + window.location.host + '/posts/internal/all-posts?campaignID=' + this.post.campaignID + '&postID=' + this.post._id,
              postDate: this.submissionReview.wantedLiveDate,
              isApprove: true
            };
            if (this.submissionReview.wantedLiveDate < utils.func.formatCustomDate(moment(), 'YYYY-MM-DD')) {
              body.isDateOverdue = true
            }
            postAPIs
              .clientApprovePost([
                {
                  id: this.post._id,
                  body
                }
              ])
              .then(async () => {
                this.$swal({
                  type: 'success',
                  title: 'Approved'
                }).then(async () => {
                  this.close()
                  this.$emit('postUpdated')
                  this.$router.push({path: '/clients/posts'})
                });
              })
              .catch(() =>
                this.$swal({
                  type: 'error',
                  title: 'Some thing went wrong'
                })
              );
          }
        });
      }
    },
    allowedDates(val) {
      let proposeDates = this.submissionReview.propose_dates
      if (Array.isArray(proposeDates) && proposeDates.length <= 3) {
        return proposeDates.includes(val)
      }
      return true
    }
  },
  watch: {
    post(newVal) {
      this.submissionReview.approveRatings = newVal.clientAcceptReview ? newVal.clientAcceptReview.rate : null
      this.submissionReview.approveSuggestion = newVal.clientAcceptReview ? newVal.clientAcceptReview.comment : null
      this.submissionReview.propose_dates = newVal.propose_dates
    }
  }
};
</script>
<style scoped>
  .choose-date {
    position: absolute;
    margin-top: 10px;
    z-index: 1;
    color: #fff;
    font-weight: 500;
    margin-left: 175px;
  }
</style>



// WEBPACK FOOTER //
// ClientChooseDateModal.vue?35f3745e